import { render } from "./HomeSolucoes.vue?vue&type=template&id=cd4d3a0c&scoped=true"
import script from "./HomeSolucoes.vue?vue&type=script&lang=js"
export * from "./HomeSolucoes.vue?vue&type=script&lang=js"

import "./HomeSolucoes.vue?vue&type=style&index=0&id=cd4d3a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd4d3a0c"]])

export default __exports__